import { useEffect, useRef } from "react";

export const useScrollToElement = (
  elementId: string | null,
  onComplete?: () => void
) => {
  const observerRef = useRef<MutationObserver | null>(null);
  const onCompleteRef = useRef(onComplete);
  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    if (!elementId) return;

    // If element exists in dom directly scroll into it
    const existingElement = document.getElementById(elementId);
    if (existingElement) {
      existingElement.scrollIntoView({ behavior: "smooth", block: "center" });
      onCompleteRef.current?.();
      return;
    }

    // Otherwise wait for it to appear in the DOM
    const observer = new MutationObserver(() => {
      const element = document.getElementById(elementId);
      if (element) {
        observer.disconnect();
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        onCompleteRef.current?.();
      }
    });

    observerRef.current = observer;
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [elementId]);
};
